// JavaScript code for acf_blocks/vertical-testimonials-caroulsel component
(($) => {

     "use strict";
     if ( ! $('.acf-blocks-vertical-testimonials-carousel').length ) {
          return;
     }
     console.log("acf_blocks/vertical-testimonials-carousel scripts loaded...");

     document.addEventListener( 'DOMContentLoaded', function() {
          const configArgs = {
               perPage: 1,
               type: 'loop',
               pagination: false,
               speed: 860,
               arrows: false,
               height: '1380px',
               autoHeight: true,
               direction: 'ttb',
               gap: '40px',
               lazyLoad: false,
               drag: false,
               focus: 'center',
               autoScroll: {
                    speed: 0.5,
                    pauseOnHover: false,
               },
          };

          const configArgs2 = Object.assign({}, configArgs, {
               autoScroll: {
                    speed: -0.5,
                    pauseOnHover: false,
               },
          });

          if ( $('.acf-blocks-vertical-testimonials-carousel .carousel-splide-1').length ) {
               const splide1 = new Splide('.acf-blocks-vertical-testimonials-carousel .carousel-splide-1', configArgs);
               splide1.on('ready', _ => $('.acf-blocks-vertical-testimonials-carousel .carousel-splide-1').addClass('is-active'));
               splide1.mount(window.splide.Extensions);
               console.log("Splide 1 mounted");
          }

          if ( $('.acf-blocks-vertical-testimonials-carousel .carousel-splide-2').length ) {
               const splide2 = new Splide('.acf-blocks-vertical-testimonials-carousel .carousel-splide-2', configArgs2);
               splide2.on('ready', _ => $('.acf-blocks-vertical-testimonials-carousel .carousel-splide-2').addClass('is-active'));
               splide2.mount(window.splide.Extensions);
          }

          if ( $('.acf-blocks-vertical-testimonials-carousel .carousel-splide-3').length ) {
               const splide3 = new Splide('.acf-blocks-vertical-testimonials-carousel .carousel-splide-3', configArgs);
               splide3.on('ready', _ => $('.acf-blocks-vertical-testimonials-carousel .carousel-splide-3').addClass('is-active'));
               splide3.mount(window.splide.Extensions);
          }

          if ( $('.acf-blocks-vertical-testimonials-carousel .carousel-single-column').length ) {
               const splide1 = new Splide('.acf-blocks-vertical-testimonials-carousel .carousel-single-column', configArgs);
               splide1.on('ready', _ => $('.acf-blocks-vertical-testimonials-carousel .carousel-single-column').addClass('is-active'));
               splide1.mount(window.splide.Extensions);
               console.log("Splide single column mounted");
          }
     });

})(jQuery);